import { render } from "./coursesForm.vue?vue&type=template&id=637e6880&scoped=true"
import script from "./coursesForm.vue?vue&type=script&lang=js"
export * from "./coursesForm.vue?vue&type=script&lang=js"

import "./coursesForm.vue?vue&type=style&index=0&id=637e6880&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-637e6880"]])

export default __exports__